import { generateApplicationUrl } from '@domain-group/javascript-utils'

type GenerateAdCopyReviewerUrlParams = {
  campaignId: number,
  orderItemId: number,
  providerId: number,
}

export const generateAdCopyReviewerUrl = (params: GenerateAdCopyReviewerUrlParams) => {
  const { campaignId, orderItemId, providerId } = params

  const adCopyReviewerModalPayload = encodeURIComponent(
    JSON.stringify({ campaign: { id: campaignId }, orderItem: { id: orderItemId }, provider: { id: providerId } }),
  )

  // @ts-expect-error TS2339
  const { applicationUrlWithHash } = generateApplicationUrl({
    applicationKey: 'realhub',
    environment: (process.env.REACT_APP_APPLICATION_ENV as 'development' | 'staging' | 'production') || 'development',
    // eslint-disable-next-line max-len
    hash: `/#/campaigns/${campaignId}/edit/adcopy?showModal=AdCopyReviewerModal&showModalPayload=${adCopyReviewerModalPayload}`,
  })

  return applicationUrlWithHash
}

export default generateAdCopyReviewerUrl
